import React, { useContext, useMemo, useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";

import Context from "../context/context";
import GridItem from './GridItem';
import GridItemEvent from './GridItemEvent';

function Grid(){
    const {filteredItems, currentPage, setCurrentPage, totalItems} = useContext(Context);

    const gridVariants = {
      hidden: { opacity: 0 },
      visible: { opacity: 1 },
    };



    const pagedItems = useMemo(() => {
      const firstPageIndex = (currentPage - 1) * 12;
      const lastPageIndex = firstPageIndex + 12;
      return filteredItems.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, filteredItems]);


    if (filteredItems.length){
      return (
          <>
          <AnimatePresence>
  <motion.div
    key={filteredItems.join(",")} // Trigger re-render and animation when items change
    initial="hidden"
    animate="visible"
    exit="hidden"
    variants={gridVariants}
    transition={{ duration: 0.3 }}
  >
            <div className="grid ">
              {
                  pagedItems.map(item =>  {
                    return <GridItem key={item.id} data={item} />

                  }
                  )
              }
            </div>
            </motion.div>
  </AnimatePresence>

          </>
      )
    } else {
      return (
        <div className="no-results ">
          No results available.
        </div>
      )
    }

}

export default Grid;
